<template>
  <ValidationObserver ref="cancelInterview">
    <BaseDialog :isOpen="isOpen">
      <template v-slot:title>
        Why do you want to cancel this interview?
      </template>
      <template v-slot:body>
        <ValidationProvider v-slot="{ errors }" name="reason" rules="required">
          <v-textarea
            :error-messages="showValidationErrors ? errors : ''"
            v-model="reason"
            height="180"
            color="primary"
            placeholder="Add comment..."
            class="mt-0"
          />
        </ValidationProvider>
      </template>
      <template v-slot:actions>
        <div>
          <PrimaryButton @click.native="close" text>
            Cancel
          </PrimaryButton>
          <ErrorButton @click.native="handleClick" :loading="isLoading">
            Cancel Interview
          </ErrorButton>
        </div>
      </template>
    </BaseDialog>
  </ValidationObserver>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { copyState } from "@/utils/helpers";
import ErrorButton from "@/components/common/Button/ErrorButton";
import { INTERVIEWS_NAMESPACE } from "@/store/modules/bookings/interviews";
import { EDIT_INTERVIEW_SLOT } from "@/store/modules/bookings/interviews/actions";
import { ADD_COMMENT } from "@/store/modules/data/actions";
import { createNamespacedHelpers } from "vuex";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { isPermissioned } from "@/utils/permissions";
import { DATA_NAMESPACE } from "@/store/modules/data";

const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);

const {
  mapActions: mapInterviewActions,
  mapState: mapInterviewState
} = createNamespacedHelpers(INTERVIEWS_NAMESPACE);

const { mapActions: mapDataActions } = createNamespacedHelpers(DATA_NAMESPACE);

export default {
  name: "CancelInterviewDialog",
  components: {
    ErrorButton,
    PrimaryButton,
    BaseDialog,
    ValidationObserver,
    ValidationProvider
  },
  props: {
    isOpen: Boolean
  },
  data() {
    return {
      isLoading: false,
      showValidationErrors: false,
      reason: ""
    };
  },
  computed: {
    ...mapAuthState({
      userData: state => state.userData
    }),
    ...mapInterviewState(copyState(["currentInterviewSlot"])),
    currentInterviewId() {
      return this.$route.params.interviewId;
    }
  },
  methods: {
    ...mapInterviewActions({
      editInterview: EDIT_INTERVIEW_SLOT
    }),
    ...mapDataActions({
      addComment: ADD_COMMENT
    }),
    async handleClick() {
      this.showValidationErrors = true;
      const isFormValid = await this.$refs.cancelInterview.validate();
      if (isFormValid) {
        this.isLoading = true;
        if (isPermissioned("interviews.edit-interview-participant.comments")) {
          await this.addComment({
            body: this.reason,
            commentableType: "interview_slot",
            commentableId: this.currentInterviewId
          });
        }
        await this.editInterview({
          id: this.currentInterviewId,
          data: {
            cancelled: true
          }
        });
        this.close();
        this.isLoading = false;
      }
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
